const INTENT_TTL_MS = 15000;
const INTENT_MAX = 16;
const studyWarmupIntents = new Map();
let studyWarmupIntentGeneration = 0;

const keyFor = value => String(value || '').trim();

export const resetStudyWarmupIntents = () => {
  studyWarmupIntents.clear();
  studyWarmupIntentGeneration = 0;
};

export const captureStudyWarmupIntentGeneration = () => studyWarmupIntentGeneration;

export const markStudyWarmupIntent = (studyInstanceUID, at = Date.now()) => {
  const key = keyFor(studyInstanceUID);
  if (!key) return;
  studyWarmupIntents.delete(key);
  while (studyWarmupIntents.size >= INTENT_MAX) {
    studyWarmupIntents.delete(studyWarmupIntents.keys().next().value);
  }
  studyWarmupIntentGeneration += 1;
  studyWarmupIntents.set(key, {
    phase: 'pending',
    startedAt: at,
    startedGeneration: studyWarmupIntentGeneration,
    acknowledgedAt: null,
    acknowledgedGeneration: null,
    expiresAt: at + INTENT_TTL_MS,
  });
};

export const acknowledgeStudyWarmupIntent = (studyInstanceUID, at = Date.now()) => {
  const key = keyFor(studyInstanceUID);
  const intent = studyWarmupIntents.get(key);
  if (!intent) return;
  studyWarmupIntentGeneration += 1;
  studyWarmupIntents.set(key, {
    ...intent,
    phase: 'acknowledged',
    acknowledgedAt: at,
    acknowledgedGeneration: studyWarmupIntentGeneration,
    expiresAt: at + INTENT_TTL_MS,
  });
};

export const failStudyWarmupIntent = studyInstanceUID => {
  studyWarmupIntents.delete(keyFor(studyInstanceUID));
};

const isServerAuthoritative = status => [
  'warming', 'ready', 'hot', 'cached', 'warm', 'complete', 'completed',
].includes(String(status || '').trim().toLowerCase());

export const reconcileStudyWarmupIntents = (studies, requestIntentGeneration, now = Date.now()) => (
  (Array.isArray(studies) ? studies : []).map(study => {
    const key = keyFor(study?.studyInstanceUID || study?.study_iuid);
    const intent = studyWarmupIntents.get(key);
    if (!intent) return study;
    if (intent.expiresAt <= now) {
      studyWarmupIntents.delete(key);
      return study;
    }
    if (isServerAuthoritative(study?.renderCacheStatus || study?.render_cache_status)) {
      studyWarmupIntents.delete(key);
      return study;
    }
    if (intent.phase === 'acknowledged' && requestIntentGeneration >= intent.acknowledgedGeneration) {
      studyWarmupIntents.delete(key);
      return study;
    }
    return {
      ...study,
      renderCacheStatus: 'warming',
      warmupPending: Math.max(1, Number(study?.warmupPending || study?.warmup_pending || 0)),
      warmupTotal: Math.max(1, Number(study?.warmupTotal || study?.warmup_total || 0)),
    };
  })
);
